<template>
  <!-- 研究 -->
  <div class="page-about">
    <div class="g-banner">
      <cmpBanner bannerType="7"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>
    <div class="g-content-wrap g-pad-top">
      <!-- 本馆概述 -->
      <div class="content" v-if="activeVal === '1'">
        <h1 class="g-title">博物馆简介</h1>
        <div class="intro g-detail-html trans">
          <p>
            辽宁省博物馆是新中国建立的第一座博物馆，成立于1949年7月7日,建馆之初名为东北博物馆，1959年改称辽宁省博物馆，2008年被评为国家一级博物馆，2009年被列为中央与地方共建国家级博物馆。辽博新馆位于沈阳市浑南区智慧三街157号，占地面积8.32万平方米，建筑面积10万余平方米，分为陈列展览、观众服务、文物库房、文物保护、综合业务等五个业务区。陈列展览区分三层，有22个现代化展厅，展陈面积2.4万平方米，是国内建筑面积和展陈面积最大的省级博物馆之一。
          </p>
          <p>
            辽博现有馆藏文物近十二万件，其中珍贵文物数万件，以辽宁地区考古出土文物和历史艺术类文物为主体，分为书法、绘画、丝绣、青铜、陶瓷等二十个门类，尤以晋唐宋元书画、宋元明清缂丝刺绣、红山文化玉器、商周时期窖藏青铜器、辽代瓷器、历代碑志、明清版画、古地图、历代货币等最具特色和影响。其中，历代书画收藏在国内外占有重要地位，素以体系完整、品质精良、精品荟萃而蜚声中外，如馆藏现存世界最早的楷书墨迹《东晋佚名曹娥诔辞》，《唐摹万岁通天帖》，“草圣”张旭《古诗四帖》，宋徽宗传世草书孤本《千字文》，传世人物画巨作唐周昉《簪花仕女图》，宋摹唐张萱《虢国夫人游春图》，五代时期中国南派山水画鼻祖董源的传世代表作《夏景山口待渡图》，宋徽宗《瑞鹤图》等，皆为稀世之珍。
          </p>
          <p>
            2018年7月，辽宁省公共文化服务中心组建，辽博作为中心重要分支机构，结合自身优势与发展规律，积极深化改革，整合资源，提高放大化学反应。举办了“又见大唐”“又见红山”“唐宋八大家主题文物展”“和合中国”等现象级大展，连续四年入围全国博物馆十大陈列展览精品推介活动，并荣获精品奖1次，优胜奖2次，博物馆改革发展的硬实力进一步凸显；积极开展文化志愿服务，“省博物馆志愿者历史文化宣讲团”入选2021年“春雨工程”全国示范性志愿服务项目，强化标准化服务能力建设，入选全国第七批社会管理和公共服务综合标准化试点项目，公共文化服务软实力持续提升；加强藏品保护与研究，获批乙级古生物化石收藏单位，入选2021年国家社科基金年度项目。通过举办现象级展览，辽博海内外影响力显著提升，2020年在由中国文物交流中心指导、文物交流智库编制的《2020年度全国博物馆（展览）海外影响力评估报告》中，辽博获评“全国博物馆海外综合影响力”和“综合类博物馆综合影响力”榜单第七和第六。2022年10月，“和合中国”展览在辽宁省博物馆开展。作为辽博史上规模最大的特展，“和合中国”展览旨在宣扬古意盎然、彬蔚称盛的文物之美，总体呈现出以主题文物展的形式解读“和合”文化、突显“和合”文化对人类社会的重要意义、通过主题文物反映中国古代以和合为美的文化与社会生活、与古为新突出人类命运共同体的天下观、部分重点文物分期展出、专业设计、举办“博物馆之夜”、为观众提供多元的服务活动八大亮点。
          </p>
          <p>
            未来，辽博将继续坚持以人民为中心的办馆方向，促进文物和文化遗产活化，不断深化拓展文物合理利用，为人民群众提供更优质的公共文化服务，对照国内外一流博物馆行业标准，积极开展具有中国特色世界一流博物馆创建工作，以文物展览宣传辽宁文化宝藏，以文化宝藏展示辽宁文化振兴，以文化振兴辉映辽宁全面振兴、全方位振兴。
          </p>
        </div>
        <div class="pics">
          <div class="pic-item" v-for="(item, i) in picList" :key="i">
            <img v-lazy="item.picUrl" alt="" />
          </div>
        </div>
        <!-- <div class="g-detail-html trans" v-html="detailData.content"></div> -->
      </div>

      <!-- 资讯 -->
      <div class="list-box list1 g-pad-bottom" v-if="activeVal === '2'">
        <div class="item g-card-2" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="pic-box">
            <img v-lazy="item.imgUrl || ''" alt="" />
          </div>
          <div class="g-border-box white">
            <div class="g-border">
              <div class="info">
                <div>
                  <!-- <p class="time">{{item.description | DateFormat('yyyy年MM月dd日')}}</p> -->
                  <p class="time m-font-2">{{ item.createTimeStr }}</p>
                  <h2 class="m-font-2">{{ item.title }}</h2>
                </div>
                <p class="desc ell m-font-4" v-html="item.content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 领导 -->
      <div class="list-box list2" v-if="activeVal === '3'">
        <div class="item g-card-2" v-for="(item, index) in data.boss" :key="index">
          <div class="g-border-box white">
            <div class="g-border">
              <div class="info">
                <h2 class="m-font-2">| {{ item.name }}</h2>
                <p class="tag m-font-2">{{ item.title }}</p>
                <p class="mt-20 m-font-4">{{ item.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 专家介绍 -->
      <div class="list-box list2" v-if="activeVal === '5'">
        <div class="item g-card-2" v-for="(item, index) in data.records" :key="index">
          <!-- <div class="pic-box">
            <img v-lazy="item.picUrl" alt="">
          </div> -->
          <div class="g-border-box white">
            <div class="g-border">
              <div class="info">
                <h2 class="m-font-2">| {{ item.name }}</h2>
                <p class="tag m-font-2">{{ item.userjob }}</p>
                <!-- <p class="tag">辽宁省博物馆展览策划部主任  中国博物馆学会展览专业委员会理事  辽宁省钱币学会常务理事</p> -->
                <!-- <div class="line"></div> -->
                <p class="desc mt-20 m-font-4" v-html="item.content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 机构设置 -->
      <div class="content con-organize" v-if="activeVal === '4'">
        <h2 class="m-font-2">
          辽宁省博物馆下设 12 个部门，具体机构设置如下表所示。
        </h2>
        <div class="org-box">
          <img v-lazy="orgPicUrl" alt="" />
        </div>
      </div>

      <!-- 制度建设 -->
      <div class="list-box list3 g-pad-bottom" v-if="activeVal === '6'">
        <div class="item g-card-2" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <!-- <div class="pic-box">
              <img v-lazy="item.picUrl" alt="">
            </div> -->
          <div class="g-border-box white">
            <div class="g-border">
              <div class="info">
                <div>
                  <h2>{{ item.title }}</h2>
                  <p class="time m-font-2">{{ item.createTimeStr }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 无数据 -->
      <div class="g-no-data" v-if="
        (activeVal === '2' || activeVal === '6') &&
        dataList.length === 0 &&
        !listLoading
      ">
        <div class="no-data-bg"></div>
        <p class="txt text-center">暂无数据</p>
      </div>

      <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total"
        @eventPage="eventPage" v-if="activeVal === '2' || activeVal === '6'"></cmpMyPagination>
    </div>
  </div>
</template>

<script>
import cmpTab from '@cmp/tab'
export default {
  components: { cmpTab },
  data() {
    return {
      activeVal: this.$route.query.pageType || '1',
      tabList: [
        {
          name: '本馆概述',
          val: '1'
        },
        {
          name: '资讯',
          val: '2'
        },
        {
          name: '领导',
          val: '3'
        },
        {
          name: '机构设置',
          val: '4'
        },
        {
          name: '制度建设',
          val: '6'
        },
        {
          name: '专家介绍',
          val: '5'
        }
      ],
      zxType: 'tzgg',
      orgPicUrl: require('@assets/images/orgPic.jpg'),
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      listLoading: false,
      data: {},
      picList: [
        // {
        //   picUrl: require('@images/museum-1.png'),
        //   link: ''
        // },
        // {
        //   picUrl: require('@images/museum-2.png'),
        //   link: ''
        // },
        // {
        //   picUrl: require('@images/museum-3.png'),
        //   link: ''
        // },
        // {
        //   picUrl: require('@images/museum-4.png'),
        //   link: ''
        // },
        // {
        //   picUrl: require('@images/museum-5.png'),
        //   link: ''
        // },
        {
          picUrl: require('@images/museum-6.png'),
          link: ''
        },
        {
          picUrl: require('@images/museum-7.png'),
          link: ''
        },
        {
          picUrl: require('@images/museum-8.png'),
          link: ''
        }
        // {
        //   picUrl: require('@images/museum-9.png'),
        //   link: ''
        // },
        // {
        //   picUrl: require('@images/museum-10.png'),
        //   link: ''
        // },
      ]
    }
  },

  watch: {
    $route(to, from) {
      if (to.query.pageType != from.query.pageType) {
        this.activeVal = to.query.pageType || '1'
      }
    }
  },
  methods: {
    getData() {
      this.$http
        .get(`../${process.env.BASE_URL}test/expert.json`, {})
        .then((res) => {
          if (res.success) {
            this.data = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    getDataList() {
      if (this.activeVal === '6') {
        this.getInfoList()
        return
      }
      this.listLoading = true
      this.$http
        .get('../singleMuseum/webapi/information', {
          ...this.listQuery
        })
        .then((res) => {
          console.log(res)
          this.listLoading = false
          if (res.success) {
            this.dataList = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 制度建设
    getInfoList() {
      this.$http
        .get('../singleMuseum/webapi/zdjs', {
          ...this.listQuery
        })
        .then((res) => {
          if (res.success) {
            this.dataList = res.result
            this.total = res.page.allRow
          }
        })
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getDataList()
    },
    eventTabClick(val) {
      console.log(val)
      this.activeVal = val
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetail(item) {
      // let routeUrl = this.$router.resolve({
      //   path: '/about/detail',
      //   query: {
      //     id: item.id,
      //     pageType: this.activeVal
      //   }
      // })
      // window.open(routeUrl.href, '_blank')

      this.$router.push({
        path: '/about/detail',
        query: { id: item.id, pageType: this.activeVal }
      })
    }
  },
  created() {
    this.getData()
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-about {
  .content {
    font-size: 14px;
    line-height: 22px;

    .intro {
      margin-top: 20px;
      color: rgba($color: #000000, $alpha: 0.7);
      font-size: 16px;
      text-indent: 32px;
      line-height: 32px;
    }

    .pics {
      padding-left: 50px;
      display: flex;
      flex-wrap: wrap;
      margin-top: 60px;

      .pic-item {
        margin-bottom: 40px;

        img {
          width: 460px;
          height: 260px;
          margin-right: 40px;
        }
      }
    }

    &.con-organize {
      h2 {
        // font-size: 24px;
        margin-bottom: 58px;
        color: rgba($color: #010101, $alpha: 0.7);
      }

      .org-box {
        text-align: center;

        img {
          width: 1490px;
          height: 374px;
        }
      }
    }
  }

  .list1 {
    .item {
      padding: 20px 0;
      margin: 0;
      border-bottom: 1px solid rgba($color: #312f2e, $alpha: 0.2);

      &:first-child {
        border-top: solid 1px $primary;
      }

      &:last-child {
        border-color: $primary;
      }
    }

    .pic-box img {
      width: 256px;
      height: 256px;
      // object-fit: contain;
      // object-position: left;
    }

    .info {
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      box-sizing: border-box;

      .time {
        // font-size: 24px;
        color: $primary;
        margin-bottom: 10px;
      }
    }
  }

  .list2 {
    .info {
      h2 {
        font-weight: normal;
        color: $primary;
      }

      .tag {
        color: #303030;
      }

      .desc {
        line-height: 32px;
      }
    }

    .item {
      margin-bottom: 0;
      padding: 40px 0;
      border-bottom: solid 1px rgba($color: #000000, $alpha: 0.2);
      cursor: initial;

      &:last-child {
        border-color: $primary;
      }

      &:first-child {
        border-top: solid 1px $primary;
      }
    }

    .g-border-box {
      padding: 0;

      .g-border {
        padding: 0;
      }
    }
  }

  .list3 {
    .item {
      padding: 20px 0;
      margin: 0;
      border-bottom: 1px solid rgba($color: #312f2e, $alpha: 0.2);

      &:first-child {
        border-top: solid 1px $primary;
      }

      &:last-child {
        border-color: $primary;
      }
    }

    .info {
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      box-sizing: border-box;

      .time {
        // font-size: 24px;
        color: $primary;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
